import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { EntityService } from 'app/projects/entity/src/lib/services/entity.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LiveCategoryLink } from '../models/live-category-link.model';
import { ILiveCategoryLinkQuery } from '../interfaces/live-category-link.query.interface';
import { IPaginatedResponse } from 'app/projects/subentity/src/lib/interfaces/paginated-response.interface';
import { CreateLiveCateogryLinkCommand } from '../models/live-category-link.command.model';
import { ILiveCategoryLinkActionPayload } from '../interfaces/live-category-link.action-payload.interface';
import { MaxBrainScheduledStreamContentBulk } from 'app/library/scheduled-stream-content/models/scheduled-stream-content-bulk.model';
import { IScheduledStreamContentBulkQuery } from 'app/library/scheduled-stream-content/interfaces/scheduled-stream-content-bulk.query.interface';
import { LiveCategoryLinkBulk } from '../models/live-category-link-bulk.model';
import { ILiveCategoryLinkBulkQuery } from '../interfaces/live-category-link-bulk.query.interface';

export interface Pagination {
    numberOfPages: number;
    numberOfResults: number;
}

@Injectable()
export class LiveCategoryLinkApiService extends EntityService<ILiveCategoryLinkQuery> {
    liveCategoryLinksPage = 1;

    private _liveCategoryLinksPagination: Pagination = { numberOfPages: 0, numberOfResults: 0 };

    get liveCategoryLinksPagination(): Pagination {
        return this._liveCategoryLinksPagination;
    }
    set liveCategoryLinksPagination(value: Pagination) {
        this._liveCategoryLinksPagination = value;
    }

    constructor(http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private environment: IEnvironment) {
        super(http, environment.apiUrl, 'engage/live-category-links');
    }

    getLiveCategoryLinks(audienceId: string, featuredStream: string, pageSize = 100, pageIndex = 1): Observable<LiveCategoryLink[]> {
        let params = new HttpParams().set('page', pageIndex.toString()).set('limit', pageSize.toString());

        if (audienceId) {
            params = params.set('filter[audience]', audienceId);
        }

        if (featuredStream) {
            params = params.set('filter[featuredStream]', featuredStream);
        }

        return this.http.get<IPaginatedResponse<ILiveCategoryLinkQuery>>(`${this.apiUrl}/${this.entities}`, { params }).pipe(
            map((query) => {
                this.liveCategoryLinksPagination = {
                    numberOfPages: query.pagination.number_of_pages,
                    numberOfResults: query.pagination.number_of_results,
                };
                return query.data.map((item) => new LiveCategoryLink(item));
            })
        );
    }

    createLiveCategoryLinks(payload: ILiveCategoryLinkActionPayload): Observable<LiveCategoryLinkBulk> {
        const data = new CreateLiveCateogryLinkCommand(payload);

        return this.http.post<ILiveCategoryLinkBulkQuery>(`${this.apiUrl}/${this.entities}`, data).pipe(map((query) => new LiveCategoryLinkBulk(query)));
    }

    removeLiveCategoryLink(liveCategoryLinkId: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/${this.entities}/${liveCategoryLinkId}`);
    }
}
